module.exports = "https://cdn.realtymogul.com/static/media/OS_careers.d67c93ac.jpg";